module.exports = __webpack_public_path__ + "media/parents/finding-the-right-college-8aed87bd.svg";